import { getLoaderEndpoint } from "@app/framework/loader";
import { pageHead } from "@app/framework/meta";
import { NotFoundPage } from "@modules/not-found/pages";
import { PressReleaseDetailsPage } from "@modules/press-releases/pages";
import { getPressRelease } from "@modules/press-releases/services";
import { getLocalizedValue } from "@modules/shared/utils";
import { trans } from "@mongez/localization";
import { LoaderFunctionArgs } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";

export async function loader({ request, params }: LoaderFunctionArgs) {
  const { id } = params;

  const { http, success, catchErrors, notFound } =
    await getLoaderEndpoint(request);

  try {
    const response = await getPressRelease(http, Number(id));

    return success(response);
  } catch (error: any) {
    // If API returns 404, handle it
    if (error?.response?.status === 404) {
      return notFound({
        error: "Press release not found",
      });
    }
    return catchErrors(error);
  }
}
export default function PressReleaseDetails() {
  const data = useLoaderData<typeof loader>();

  if (!data?.new) {
    return <NotFoundPage />;
  }

  return <PressReleaseDetailsPage pressRelease={data.new} />;
}

export function meta({ data }: any) {
  return pageHead({
    title: `${getLocalizedValue(data?.new?.title)} - ${trans("pressReleasesDetailsPage.title")}`,
    description: trans("pressReleasesDetailsPage.description"),
  });
}
